// extracted by mini-css-extract-plugin
module.exports = {"banner-picture":"banner-picture-54bb8a894d59f8232eb05309f7652c73"};